export const CAL_EVENT_PHOTO_MAX_BYTES = 10 * 1024 * 1024;
//# sourceMappingURL=cal-event-photo-max-bytes.js.map